import {
  type CreateMaterialRequest,
  CreateMaterialResponse,
  MaterialListResponse,
} from "@edu/shared";
import { call, callVoid } from "../../lib/api.ts";

/**
 * Четыре ручки преподавателя для ссылок и файлов, отправленных ученику
 * (`docs/material-receipt-design.md`, раздел 13, часть А).
 *
 * Живут здесь, а не в `lib/api.ts`, по той же соседской причине, что ручки
 * панели «Где дыры» (`student-skills-api.ts`): схемы нужны ровно одному экрану,
 * карточке ученика. Базовый адрес, cookie и разбор отказов общие, наружу отсюда
 * уезжает только `call`, второго HTTP-клиента не заводится.
 *
 * ⚠️ Публичной ручки `GET /v1/materials/:id` и отметки об открытии здесь нет:
 * первая это часть Б проекта, вторую шлёт экран ученика (`features/materials/`).
 */

/**
 * Отправить материал. Повтор с тем же `requestId` возвращает ТОТ ЖЕ материал с
 * `repeated: true` (раздел 5 проекта), и экран обязан это различать.
 */
export function createMaterial(body: CreateMaterialRequest): Promise<CreateMaterialResponse> {
  return call("/v1/materials", { method: "POST", body }, CreateMaterialResponse);
}

/**
 * Страница материалов одного ученика, новые сверху. Без курсора первая
 * страница, с курсором догрузка (курсор возвращается как есть).
 */
export function listMaterials(
  studentUserId: string,
  cursor: string | null,
): Promise<MaterialListResponse> {
  const params = new URLSearchParams({ studentId: studentUserId });
  if (cursor !== null) params.set("cursor", cursor);
  return call(`/v1/materials?${params.toString()}`, {}, MaterialListResponse);
}

/** Отзыв: ученик перестаёт видеть материал, квитанция остаётся. Обратного пути нет. */
export function revokeMaterial(materialId: string): Promise<void> {
  return callVoid(`/v1/materials/${materialId}/revoke`, { method: "POST" });
}

/** Удаление: материал пропадает у обоих вместе с квитанцией. */
export function deleteMaterial(materialId: string): Promise<void> {
  return callVoid(`/v1/materials/${materialId}`, { method: "DELETE" });
}
